/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov, Leonid Khramov, Slobodan Djordjevic
 */
import React, { useState } from "react"
import { formatFullName } from "../../../trace/formatters"
import { DropdownMenu, Element, Color, Label, isMobileScreen } from "trux"
import "./TracerItem.css"

const TracerItem = (props) => {
    const [isHovered, setHovered] = useState(false)

    const traceNumber = () => {
        const item = props.item || {}
        var traceNumber = parseInt(item.default_trace_number, 10)
        // eslint-disable-next-line eqeqeq
        if (traceNumber <= 0 || traceNumber == null) {
            traceNumber = "?"
        }
        return traceNumber
    }

    const jerseyNumber = () => {
        const item = props.item || {}
        var jerseyNumber =
            item.jersey_number === "" ? " tbd" : item.jersey_number
        return "Jersey #" + jerseyNumber
    }

    const onRemoveClick = (e) => {
        if (e) {
            e.preventDefault()
        }
        if (props.onRemoveClick) {
            props.onRemoveClick(props.item)
        }
    }

    const onSwapClick = (e) => {
        if (e) {
            e.preventDefault()
        }
        if (props.onSwapClick) {
            props.onSwapClick(props.item)
        }
    }

    const onEditClick = (e) => {
        if (e) {
            e.preventDefault()
        }
        if (props.onEditClick) {
            props.onEditClick(props.item)
        }
    }

    const onTraceiDClick = (e) => {
        if (e) {
            e.preventDefault()
        }
        if (props.onTraceiDClick) {
            props.onTraceiDClick({ user_id: props.item.user_id })
        }
    }

    const onChange = (e, val) => {
        if (val === "remove") {
            onRemoveClick()
        } else if (val === "swap") {
            onSwapClick()
        } else if (val === "edit") {
            onEditClick()
        } else if (val === "trace") {
            onTraceiDClick()
        }
    }

    const item = props.item || {}
    let emailCount = item.noOfEmails
        ? item.noOfEmails === 1
            ? "1 Email"
            : `${item.noOfEmails} Emails`
        : "No Email"

    const disabledClass = item.user.is_dummy ? "disabled" : ""
    var unassignedClass = ""
    if (item.user.is_dummy === 0 && item.default_trace_number <= 0) {
        unassignedClass = "unassigned"
    }

    let options = []

    if (props.item && props.item.user) {
        if (traceNumber() === "?") {
            options = [
                {
                    title: "Move this player to a Tracer",
                    value: "swap",
                },
                {
                    title: "Contact Info",
                    value: "edit",
                },
                {
                    title: "Trace iD",
                    value: "trace",
                },
            ]
        } else {
            options = [
                {
                    title: "Remove from Tracer #" + traceNumber(),
                    value: "remove",
                },
                {
                    title: "Move to another Tracer",
                    value: "swap",
                },
                {
                    title: "Contact Info",
                    value: "edit",
                },
                {
                    title: "Trace iD",
                    value: "trace",
                },
            ]
        }
    }

    if (disabledClass.length === 0) {
        return (
            <DropdownMenu
                title="TracerItem"
                options={options}
                onChange={onChange}
                classNameMenu={`TracerItem tracer-dropdown ${unassignedClass} ${disabledClass}`}
                menuDirection={"bottom"}
                menuPortal={"#modal-root"}
                buttonHeight={"50"}
                offsetAxisY={8}
                background={isHovered ? Color.Grey4 : Color.White2}
                buttonWidth={`${
                    isMobileScreen() ? "100%" : "calc(33.3% - 20px)"
                }`}
                button={
                    <Element
                        trkAction="TracerItem Pressed"
                        id={`player-${item.user_id}`}
                        className="tracer-dropdown-item"
                        onMouseEnter={() => setHovered(true)}
                        onMouseLeave={() => setHovered(false)}
                    >
                        <Element className="number-shield">
                            <Label className="number">{traceNumber()}</Label>
                        </Element>
                        <Element className="content">
                            <Label className="name" bold color={Color.Black}>
                                {formatFullName(item)}
                            </Label>
                            <Label className="contact">
                                {jerseyNumber()} • {emailCount}
                            </Label>
                            <Label
                                className="contact"
                                style={{ display: "none" }}
                            >
                                {item.game_player_id} GameId
                            </Label>
                        </Element>
                    </Element>
                }
            />
        )
    } else {
        return (
            <Element
                id={`player-${item.user_id}`}
                onClick={onEditClick}
                className={`TracerItem ${unassignedClass} ${disabledClass}`}
            >
                <Element className="number-shield">
                    <Label className="number">{traceNumber()}</Label>
                </Element>
                <Element className="content">
                    <Label className="name" bold color={Color.Grey3}>
                        {formatFullName(item)}
                    </Label>
                    <Label className="contact">
                        {jerseyNumber()} • {emailCount}
                    </Label>
                    <Label className="contact" style={{ display: "none" }}>
                        {item.game_player_id} GameId
                    </Label>
                </Element>
            </Element>
        )
    }
}

export default TracerItem
